export const HOME = "/";
export const DASHBOARD = "/dashboard";
export const FEATURES = "/features";
export const PLANS = "/plans";
export const TUTORIALS = "/tutorials";
export const DOWNLOAD = "/download";
export const REVIEWS = "/reviews";
export const FAQ = "/mostAskedQuestions";
export const NOTFOUND = "*";
